var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    stroke: "#500D76",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "{stroke}",
    d: "M29 6.333a1 1 0 1 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3v-3zm-19.667 5a1 1 0 0 0-.894.553l-4 8a1 1 0 0 0-.106.447v8A3.666 3.666 0 0 0 8 32h1.667v.32a1 1 0 0 0 1 1h3.945a1 1 0 0 0 1-1V32h8.721v.32a1 1 0 0 0 1 1h3.946a1 1 0 0 0 1-1V32h1.72a3.666 3.666 0 0 0 3.668-3.667v-8a1 1 0 0 0-.106-.447l-2-4a1 1 0 1 0-1.789.894l1.277 2.553H6.95l3-6h9.674a1 1 0 1 0 0-2H9.333zM29.28 30H8a1.667 1.667 0 0 1-1.667-1.667v-7h27.334v7A1.666 1.666 0 0 1 32 30h-2.721zm-15.946-5.667h-2.666V27h2.666v-2.667zm2.667 0h2.667V27H16v-2.667zm8 0h-2.667V27H24v-2.667zm2.667 0h2.666V27h-2.666v-2.667z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredSwitch);
export default __webpack_public_path__ + "static/media/coloredSwitch.d029bed2102403f75d6b91001d310689.svg";
export { ForwardRef as ReactComponent };